import * as React from 'react';
import { Checkbox } from '@cian/ui-kit';

interface IApartmentsWithDecorationProps {
  apartmentsWithDecoration: boolean;
  onChange: (event: React.SyntheticEvent, value: boolean) => void;
}

export function ApartmentsWithDecoration({ apartmentsWithDecoration, onChange }: IApartmentsWithDecorationProps) {
  return <Checkbox label="С отделкой" checked={apartmentsWithDecoration} onChange={onChange} />;
}
